
















import { Vue, Component, Prop } from "vue-property-decorator";
import CardTitle from "../CardTitle.vue";
import * as images from "../../assets/images";
//@ts-ignore
import * as pdfMake from "pdfmake/build/pdfmake";
//@ts-ignore
import * as pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  components: {
    CardTitle
  }
})

export default class IspezioneReview extends Vue {
    @Prop() docInfo!: any;

    private firmaAzienda: string;

    constructor(){
        super()
        this.firmaAzienda = ""
    }

    createDoc(){
        var dd = {
            pageSize: "A4",
            content: [
                {
                    table: {
                        widths: ["*"],
                        alignment: "center",
                        body: [
                            [
                                {
                                    text: "FSL - VERBALE VISITA PRELIMINARE",
                                    alignment: "center",
                                    bold: true,
                                    fontSize: 15
                                }
                            ]
                        ]    
                    }
                },
                {
                    text: "",
                    margin: [0, 0, 0, 5]
                },
                {
                    table: {
                        widths: [150, "*"],
                        alignment: "center",
                        body: [
                            [
                                {
                                    text: "Azienda: ",
                                    bold: true,
                                    style: "tableTitle"
                                },
                                {
                                    text: this.docInfo.denominazioneAzienda,
                                    style: "bodyText"
                                }
                            ],
                            [
                                {
                                    text: "Data Ispezione: ",
                                    bold: true,
                                    style: "tableTitle"
                                },
                                {
                                    text: this.docInfo.dataIspezione,
                                    style: "bodyText"
                                }  
                            ],
                            [
                                {
                                    text: "Ora Ispezione: ",
                                    bold: true,
                                    style: "tableTitle"
                                },
                                {
                                    text: this.docInfo.oraIspezione,
                                    style: "bodyText"
                                }
                            ],
                            [
                                {
                                    text: "Osservatore: ",
                                    bold: true,
                                    style: "tableTitle"
                                },
                                {
                                    text: this.docInfo.osservatore,
                                    style: "bodyText"
                                }
                            ]
                        ]
                    }
                },
                {
                    text: "",
                    margin: [0, 0, 0, 10]
                },
                {
                    table: {
                        widths: ["*"],
                        alignment: "center",
                        body: [
                            [
                                {
                                    text: "PERSONALE AZIENDALE di accompagnamento",
                                    alignment: "center",
                                    fontSize: 10,
                                    bold: true
                                }
                            ]
                        ]    
                    }
                },
                {
                    text: "",
                    margin: [0, 0, 0, 5]
                },
                {
                    table: {
                        widths: ["*","*"],
                        alignment: "center",
                        body: [
                            [
                                {
                                    text: "Cognome Nome",
                                    style: "tableTitle",
                                    bold: true
                                },
                                {
                                    text: "Ruolo Aziendale",
                                    style: "tableTitle",
                                    bold: true
                                }
                            ],
                            [
                                {
                                    text: this.docInfo.personaleUno,
                                    style: "bodyText"
                                },
                                {
                                    text: this.docInfo.ruoloUno,
                                    style: "bodyText"
                                }
                            ],
                            [
                                {
                                    text: this.docInfo.personaleDue,
                                    style: "bodyText"
                                },
                                {
                                    text: this.docInfo.ruoloDue,
                                    style: "bodyText"
                                }
                            ]
                        ]   
                    }
                },
                {
                    text: "",
                    margin: [0, 0, 0, 10]
                },
                {
                    table: {
                        widths: ["*"],
                        alignment: "center",
                        body: [
                            [
                                {
                                    text: "AMBIENTI VISITATI E ATTREZZATURE",
                                    alignment: "center",
                                    fontSize: 10,
                                    bold: true
                                }  
                            ]
                        ]
                    }
                },
                {
                    text: "",
                    margin: [0, 0, 0, 5]
                },
                {
                    table: {
                        widths: ["*",150,150],
                        alignment: "center",
                        body: [
                            [
                                {
                                    text: "Ambiente visitato",
                                    style: "tableTitle"
                                },
                                {
                                    text: "E' idoneo allo svolgimento della FSL?",
                                    style: "tableTitle"
                                },
                                {
                                    text: "Le attrezzature utilizzate sono idonee allo svolgimento della FSL?",
                                    style: "tableTitle"
                                }
                            ],
                            [
                                {
                                    text: "Uffici (" + this.docInfo.checkUffici + ")",
                                    style: "tableTitle"
                                },
                                {
                                    text: this.docInfo.ambienteUfficiIdoneo,
                                    alignment: "center",
                                    style: "bodyText"
                                },
                                {
                                    text: this.docInfo.attrezUfficiIdonea,
                                    alignment: "center",
                                    style: "bodyText"
                                }
                            ],
                            [
                                {
                                    text: "Reparti di lavorazione (" + this.docInfo.checkRepLavorazione + ")",
                                    style: "tableTitle"
                                },
                                {
                                    text: this.docInfo.ambienteRepLavorazioneIdoneo,
                                    alignment: "center",
                                    style: "bodyText"
                                },
                                {
                                    text: this.docInfo.attrezRepLAvorazioneIdonea,
                                    alignment: "center",
                                    style: "bodyText"
                                }
                            ],
                            [
                                {
                                    text: "Reparti di assemblaggio (" + this.docInfo.checkRepAssemblaggio + ")",
                                    style: "tableTitle"
                                },
                                {
                                    text: this.docInfo.ambienteRepAssemblaggioIdoneo,
                                    alignment: "center",
                                    style: "bodyText"
                                },
                                {
                                    text: this.docInfo.attrezRepAssemblaggioIdonea,
                                    alignment: "center",
                                    style: "bodyText"
                                }
                            ],
                            [
                                {
                                    text: "Magazzino (" + this.docInfo.checkMagazzino + ")",
                                    style: "tableTitle"
                                },
                                {
                                    text: this.docInfo.ambienteMagazzinoIdoneo,
                                    alignment: "center",
                                    style: "bodyText"
                                },
                                {
                                    text: this.docInfo.attrezMagazzinnoIdonea,
                                    alignment: "center",
                                    style: "bodyText"
                                }
                            ],
                            [
                                {
                                    text: "Area arrivi/spedizione merci (" + this.docInfo.checkSpedizioni + ")",
                                    style: "tableTitle"
                                },
                                {
                                    text: this.docInfo.ambienteSpedizioniIdoneo,
                                    alignment: "center",
                                    style: "bodyText"
                                },
                                {
                                    text: this.docInfo.attrezSpedizioniIdonea,
                                    alignment: "center",
                                    style: "bodyText"
                                }
                            ],
                            [
                                {
                                    text: "Cantiere esterno (" + this.docInfo.checkCantiere + ")",
                                    style: "tableTitle"
                                },
                                {
                                    text: this.docInfo.ambienteCantiereIdoneo,
                                    alignment: "center",
                                    style: "bodyText"
                                },
                                {
                                    text: this.docInfo.attrezCantiereIdonea,
                                    alignment: "center",
                                    style: "bodyText"
                                }
                            ]
                        ]    
                    }                    
                },
                {
                    text: "E' stato permesso di visitare tutti gli ambienti sede della futura FSL? " + this.docInfo.ambientiVisitati,
                    style: "bodyText",
                    margin: [0, 5, 0, 0]
                },
                {
                    text: "Motivazione in caso di NO: " + this.docInfo.noteAmbientiVisitati,
                    style: "bodyText"
                },
                {
                    text: "",
                    margin: [0, 0, 0, 10]
                },
                {
                    table: {
                        widths: ["*"],
                        alignment: "center",  
                        body: [
                            [
                                {
                                    text: "VALUTAZIONE FINALE",
                                    alignment: "center",
                                    fontSize: 10,
                                    bold: true
                                }
                            ]
                        ] 
                    }
                },
                {
                    text: "",
                    margin: [0, 0, 0, 5]
                },
                {
                    text: "Ambienti e attrezzature sono coerenti con lo svolgimento di una FSL? " + this.docInfo.valutazioneFinale,
                    style: "bodyText"
                },
                {
                    text: "Osservazioni finali: " + this.docInfo.osservazioniFinali,
                    style: "bodyText"
                },
                {
                    text: "Il Tutor Scolastico / docente in visita (firma)",
                    alignment: "right",
                    style: "bodyText",
                    bold: true
                },
                {
                    image: this.docInfo.firmaIspettore,
                    width: 200,
                    alignment: "right"
                },
                {
                    text: "Il Legale Rappresentante (firma)",
                    alignment: "right",
                    style: "bodyText",
                    bold: true
                },
                {
                    image: this.firmaAzienda,
                    width: 200,
                    alignment: "right"
                }
            ],
            styles: {
                bodyText: {
                    fontSize: 8,
                    justified: true
                },
                tableTitle: {
                    fontSize: 8,
                    bold: "true"
                },
                tableText: {
                    fontSize : 8
                },
                bodyTextHighlight: {
                    fontSize: 10,
                    justified: true,
                    background: "yellow"
            }
        } 
        }
        const pdfDocGenerator = pdfMake.createPdf(dd);
        pdfDocGenerator.getDataUrl(function(dataUrl: any) {
        const targetElement = document.querySelector("#iframeContainer");
        const embed = document.createElement("embed");
        embed.src = dataUrl;
        embed.id = "pdfPreview";
        embed.width = "1000";
        embed.height = "700";
        if (targetElement !== null) {
            targetElement.appendChild(embed);
        }
        });
    }

    calculateValues(){
        this.docInfo.checkUffici = this.docInfo.checkUffici ? 'X' : ''
        if(this.docInfo.checkUffici === 'X'){
            this.docInfo.ambienteUfficiIdoneo = this.docInfo.ambienteUfficiIdoneo ? 'SI' : 'NO'
            this.docInfo.attrezUfficiIdonea = this.docInfo.attrezUfficiIdonea ? 'SI' : 'NO'
        }else {
            this.docInfo.ambienteUfficiIdoneo = ''
            this.docInfo.attrezUfficiIdonea = ''
        }
        this.docInfo.checkRepLavorazione = this.docInfo.checkRepLavorazione ? 'X' : ''
        if(this.docInfo.checkRepLavorazione === 'X'){
            this.docInfo.ambienteRepLavorazioneIdoneo = this.docInfo.ambienteRepLavorazioneIdoneo ? 'SI' : 'NO'
            this.docInfo.attrezRepLAvorazioneIdonea = this.docInfo.attrezRepLAvorazioneIdonea ? 'SI' : 'NO'
        }else{
            this.docInfo.ambienteRepLavorazioneIdoneo = ''
            this.docInfo.attrezRepLAvorazioneIdonea = ''
        }
        this.docInfo.checkRepAssemblaggio = this.docInfo.checkRepAssemblaggio ? 'X' : ''
        if(this.docInfo.checkRepAssemblaggio === 'X'){
            this.docInfo.ambienteRepAssemblaggioIdoneo = this.docInfo.ambienteRepAssemblaggioIdoneo ? 'SI' : 'NO'
            this.docInfo.attrezRepAssemblaggioIdonea = this.docInfo.attrezRepAssemblaggioIdonea ? 'SI' : 'NO'
        }else{
            this.docInfo.ambienteRepAssemblaggioIdoneo = ''
            this.docInfo.attrezRepAssemblaggioIdonea = ''
        }
        this.docInfo.checkMagazzino = this.docInfo.checkMagazzino ? 'X' : ''
        if(this.docInfo.checkMagazzino === 'X'){
            this.docInfo.ambienteMagazzinoIdoneo = this.docInfo.ambienteMagazzinoIdoneo ? 'SI' : 'NO'
            this.docInfo.attrezMagazzinnoIdonea = this.docInfo.attrezMagazzinnoIdonea ? 'SI' : 'NO'
        }else{
            this.docInfo.ambienteMagazzinoIdoneo = this.docInfo.ambienteMagazzinoIdoneo ? '' : ''
            this.docInfo.attrezMagazzinnoIdonea = this.docInfo.attrezMagazzinnoIdonea ? '' : ''
        }
        this.docInfo.checkSpedizioni = this.docInfo.checkSpedizioni ? 'X' : ''
        if(this.docInfo.checkSpedizioni === 'X'){
            this.docInfo.ambienteSpedizioniIdoneo = this.docInfo.ambienteSpedizioniIdoneo ? 'SI' : 'NO'
            this.docInfo.attrezSpedizioniIdonea = this.docInfo.attrezSpedizioniIdonea ? 'SI' : 'NO'
        }else{
            this.docInfo.ambienteSpedizioniIdoneo = this.docInfo.ambienteSpedizioniIdoneo ? '' : ''
            this.docInfo.attrezSpedizioniIdonea = this.docInfo.attrezSpedizioniIdonea ? '' : ''
        }
        this.docInfo.checkCantiere = this.docInfo.checkCantiere ? 'X' : ''
        if(this.docInfo.checkCantiere === 'X'){
            this.docInfo.ambienteCantiereIdoneo = this.docInfo.ambienteCantiereIdoneo ? 'SI' : 'NO'
            this.docInfo.attrezCantiereIdonea = this.docInfo.attrezCantiereIdonea ? 'SI' : 'NO'
        }else{
            this.docInfo.ambienteCantiereIdoneo = ''
            this.docInfo.attrezCantiereIdonea = ''
        }       
        
        this.docInfo.ambientiVisitati = this.docInfo.ambientiVisitati ? 'SI' : 'NO'
        this.docInfo.valutazioneFinale = this.docInfo.valutazioneFinale ? 'SI' : 'NO'

        if(this.docInfo.firmaRappresentanteAzienda !== null && this.docInfo.firmaRappresentanteAzienda !== ''){
            this.firmaAzienda = this.docInfo.firmaRappresentanteAzienda
        }else{
            this.firmaAzienda = images.noFirma
        }

        this.createDoc()
    }

    created() {
        this.calculateValues()
    }
} 
